// src/admin/purge/usePurgePreview.js — loads a purge preview when its dialog opens (v206).
// A sequence ticket guards then/catch: an answer that arrives after the dialog closed (or reopened, or reloaded)
// never lands. `reload()` reads the preview again while the dialog stays open (a blocker that clears by itself).
import { useCallback, useEffect, useRef, useState } from 'react';

const IDLE = { loading: false, preview: null, error: null };

export function usePurgePreview(open, load) {
  const [state, setState] = useState(IDLE);
  const [attempt, setAttempt] = useState(0);
  const ticket = useRef(0);
  const loadRef = useRef(load);
  loadRef.current = load;

  useEffect(() => {
    ticket.current += 1;
    if (!open) {
      setState(IDLE);
      return;
    }
    const mine = ticket.current;
    setState({ loading: true, preview: null, error: null });
    // load() is called synchronously (the request starts with the open); the executor turns a sync throw into a
    // rejection.
    new Promise((resolve) => { resolve(loadRef.current()); })
      .then(
        (preview) => { if (ticket.current === mine) setState({ loading: false, preview, error: null }); },
        (error) => { if (ticket.current === mine) setState({ loading: false, preview: null, error }); },
      );
  }, [open, attempt]);

  const reload = useCallback(() => setAttempt((n) => n + 1), []);
  return { ...state, reload };
}
